<template>
  <v-container class="pa-0 ma-0">
    <base-material-card
      v-if="standalone"
      icon="mdi-chart-timeline-variant"
      class="px-5 py-3"
      :title="title"
      :subtitle="subtitle"
      :color="color"
    >
      <chart-theme-u
        :is-loaded="isLoaded"
        :has-error="hasError"
        :theme-data="datas"
        :error-msg="errorMsg"
        :error-empty="errorEmpty"
        :labels="labels"
        :manual-ticks-limit="manualTicksLimit"
      />
    </base-material-card>
    <v-card
      v-else
      flat
    >
      <chart-theme-u
        :is-loaded="isLoaded"
        :has-error="hasError"
        :theme-data="datas"
        :error-msg="errorMsg"
        :error-empty="errorEmpty"
        :labels="labels"
        :manual-ticks-limit="manualTicksLimit"
      />
    </v-card>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import ChartThemeU from './ChartThemeU.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'ChartCard',

    /* Sous-composants utilisés par ce composant */
    components: {
      ChartThemeU,
    },

    /* Paramètres */
    props: {
      standalone: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: '',
      },
      subtitle: {
        type: String,
        default: '',
      },
      isLoaded: {
        type: Boolean,
        default: false,
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      themeData: Object,
      lineOptions: Object,
      errorMsg: {
        type: String,
        default: '',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      color: {
        type: String,
        default: 'primary',
      },
      labels: {
        type: Object,
        default: function () {
          return {
            x: 'Mois',
            y: 'Note',
          }
        },
      },
      manualTicksLimit: {
        type: Boolean,
        default: true,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        datas: undefined,
      }
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    /* computed: {
      data: function () {
        if (this.labels.x === 'Semaines' && this.themeData && this.themeData.datasets[0]) {
          // console.log(this.themeData.labels, this.themeData.datasets[0].data)
        }
        return this.themeData
      },
    }, */

    watch: {
      themeData: {
        deep: true,
        handler: function () {
          this.datas = this.themeData
        },
      },
    },
  }
</script>
